/* /src/routes/privateRoute.jsx */
import React from "react";
import { Route } from "react-router-dom";
import { AuthConsumer } from "../contexts/authProvider";

// header + footer components
import Header from '../components/wrapper/Header/Header';
import Footer from '../components/wrapper/Footer/Footer';
import LoadingIndicator from '../components/wrapper/LoadingIndicator/LoadingIndicator';

export const PrivateRoute = ({ component, ...rest }) => {

    const renderFn = (Component) => (props) => (
        <AuthConsumer>
            {({ isAuthenticated, signinRedirect }) => {
                if (!!Component && isAuthenticated()) {
                    return (
                        <>
                        <Header />
                            <Component {...props} />
                        <Footer />
                        </>
                    );
                } else {
                    signinRedirect();
                    return <LoadingIndicator active={true} />;
                }
            }}
        </AuthConsumer>
    );

    return <Route exact={true} {...rest} render={renderFn(component)} />;
};